import { useState, useCallback } from 'react';

/**
 * Стейт-машина правой панели вкладки «База знаний».
 *
 * 4 состояния:
 *  - 'welcome' — ничего не выбрано, показываем приветствие/CTA
 *  - 'add-document' — форма загрузки документов (Пакет 2)
 *  - 'add-site' — форма парсинга сайта (Пакет 3-4)
 *  - 'detail' — детали выбранного источника (статистика/удаление)
 *
 * В состоянии 'detail' хранится selectedSourceId — какую карточку
 * пользователь раскрыл слева. На остальных состояниях он null.
 *
 * Выбор источника живёт в useState (не в URL) по решению владельца —
 * нет требования на shareable-ссылку, refresh откатывает в welcome.
 */
export type PanelState =
  | { mode: 'welcome' }
  | { mode: 'add-document' }
  | { mode: 'add-site' }
  | { mode: 'detail'; sourceId: string };

export function usePanelState() {
  const [state, setState] = useState<PanelState>({ mode: 'welcome' });

  const goWelcome = useCallback(() => {
    setState({ mode: 'welcome' });
  }, []);

  const goAddDocument = useCallback(() => {
    setState({ mode: 'add-document' });
  }, []);

  const goAddSite = useCallback(() => {
    setState({ mode: 'add-site' });
  }, []);

  const selectSource = useCallback((sourceId: string) => {
    setState({ mode: 'detail', sourceId });
  }, []);

  return {
    state,
    goWelcome,
    goAddDocument,
    goAddSite,
    selectSource,
  };
}
